module.exports = __webpack_public_path__ + "assets/close-red-c83c68.svg";